import { EventFormQuestion } from "@ac-expo/api-types";
import { Control } from "react-hook-form";
import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { FormRadio } from "../form/FormRadio";
import { Label } from "../Label";
import { RadioGroup, RadioGroupItem } from "../RadioGroup";

interface EventFormCheckboxProps {
  question: EventFormQuestion;
  control?: Control<CreateEventFormAnswersForm>;
  index?: number;
  isReadOnly?: boolean;
}

export default function EventFormCheckbox({
  question,
  control,
  index,
  isReadOnly = false,
}: EventFormCheckboxProps) {
  if (isReadOnly) {
    return (
      <div className="space-y-[6px]">
        <Label className="text-sm text-gray-600">
          {question.theme} : {question.question}
        </Label>
        <RadioGroup className="grid grid-cols-3 gap-2 rounded-xl bg-gray-50 p-4">
          {question.options.map((option) => (
            <div key={option.label} className="flex items-center space-x-2">
              <RadioGroupItem value={option.label} id={option.label} />
              <Label
                htmlFor={option.label}
                className="text-sm font-bold text-gray-500"
              >
                {option.label}
              </Label>
            </div>
          ))}
        </RadioGroup>
      </div>
    );
  }

  if (!control || index === undefined) {
    throw new Error(
      "control and index are required when not in read-only mode"
    );
  }

  return (
    <div key={question.id} className="space-y-[6px]">
      <label className="text-sm text-gray-600">
        {question.theme} : {question.question}
      </label>
      <FormRadio
        control={control}
        name={`answers.${index}.answer`}
        radioItems={question.options.map((option) => ({
          label: option.label,
          value: option.label,
        }))}
        containerClassName="grid grid-cols-3 gap-2 rounded-xl bg-gray-50 p-4"
        labelClassName="text-sm font-bold text-gray-500"
      />
    </div>
  );
}